import React, { ReactNode } from 'react';
import { Link, To } from 'react-router-dom';

import { LogoPictogramIcon } from '../../assets';
import { Container } from '../../components';
import { NavItem } from './NavItem';

import styles from './Header.module.scss';

export interface IHeaderProps {
    logoLink?: To;
    routes?: {
        title: string;
        url: To;
    }[];
    rightSlot?: ReactNode;
}

export const Header = ({ logoLink, routes, rightSlot }: IHeaderProps) => {
    return (
        <header className={styles.header}>
            <Container size="full" className={styles.container}>
                <nav className={styles.nav}>
                    <Link to={logoLink || '/'}>
                        <LogoPictogramIcon className={styles.logo} />
                    </Link>
                    <ul className={styles.navList}>
                        {routes?.map(({ title, url }) => <NavItem key={url.toString()} title={title} url={url} />)}
                    </ul>
                </nav>
                <div className={styles.rightSlot}>{rightSlot}</div>
            </Container>
        </header>
    );
};
